import * as React from 'react';
import { ReactNode, useContext } from 'react';
import { StateContext, StateContextType } from '../../util/providers/StateProvider';
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
import { Link } from 'react-router';
import { Statistics } from './components/Statistics';
import { AuthContext } from '../../Auth/components/AuthProvider';
import { HomepageData, HomepageRowElement } from './types';
import { getBanner } from '../../Settings/mandants/getBanner';
import { SvgComponentOrcidLink } from '../../Settings/img/homepage/orcid-link';
import SvgComponentPublicationEmbed from '../../Settings/img/homepage/publication-embed';
import SvgComponentWorkReport from '../../Settings/img/homepage/work-report';
import { EmbeddedSearchbar } from '../components/EmbeddedSearchbar';

export function Homepage(): ReactNode {
  const state: StateContextType = useContext(StateContext);
  const homepageData: HomepageData[] = state.homepageData;
  const {actions} = useContext(AuthContext);

  const intl: IntlShape = useIntl();
  const header: ReactNode = <div className={'block bg-cover py-8'}
                                 style={{
                                   backgroundPosition: 'center center', backgroundImage: `url(${getBanner((state.originMandantSettings.mandant))})`}}>
    <div className={'block flex align-content-center justify-content-center m-5 mx-auto'}>
      <h1 className={'md:m-5 primary-bg border-round px-3 py-2 shadowed'} style={{textAlign: 'center', fontSize: 'calc(12px + 1.8vw)'}}>
        <FormattedMessage id={`${state?.originMandantSettings?.mandant || 'rub'}.homepage.title`}/>
      </h1>
    </div>
    <div className={'block flex align-content-center justify-content-center m-5 mx-auto'}
         style={{maxWidth: '50em', width: '90%', minWidth: '20em'}}>
      <EmbeddedSearchbar/>
    </div>
  </div>;

  const renderSvg = (key: string): ReactNode => {
    switch (key) {
      case 'orcid-link': return <SvgComponentOrcidLink style={{fill: 'var(--primary-color)'}}/>;
      case 'work-report': return <SvgComponentWorkReport style={{fill: 'var(--primary-color)'}}/>;
      case 'publication-embed': return <SvgComponentPublicationEmbed style={{fill: 'var(--primary-color)'}}/>;
      default: return <></>;
    }
  };

  const renderElement = (data: HomepageRowElement): ReactNode => {
    switch (data.type) {
      case 'html':
        return (
          <div className={'w-full'}>
            {!!data.element.headline && (
              <h2 className={'my-2 text-xl sm:text-2xl md:text-4xl'}>
                <FormattedMessage id={data.element.headline} />
              </h2>
            )}
            {!!data.element.text && (
              <p
                className={'mb-3 homepage-parsed-text'}
                dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: data.element.text }) }}
              ></p>
            )}
            {!!data.element.button && state.originMandantSettings.loginEnabled && (
              <Link
                className="p-button font-bold shadowed"
                to={data.element.button.to === 'AUTH' ? actions.getAuthUrl() : data.element.button.to}
              >
                <FormattedMessage id={data.element.button.label} />
              </Link>
            )}
          </div>
        );
      case 'svg':
        return (
          <div className={'w-full max-w-20rem m-5 flex justify-content-center'}>
            {renderSvg(data.element.src)}
          </div>
        );
      default:
        return <></>;
    }
  };

  return (
    <div>
      {header}
      <div>
        {homepageData.map((row: HomepageData, rowIndex: number): ReactNode => {
          const oddRow: boolean = !(rowIndex % 2 === 0);
          return <div key={rowIndex} className={`${oddRow ? 'surface-100' : ''} flex justify-content-around`}>
            <div
              className={`w-12 flex ${row.reverseOnMobile ? 'flex-column-reverse' : 'flex-column'} md:flex-row justify-content-center m-5 column-gap-8`}>
              <div className={'w-12 md:w-6 xl:w-4 flex justify-content-center'}>
                {renderElement(row.elements.left)}
              </div>
              <div className={'w-12 md:w-6 xl:w-4 flex justify-content-center'}>
                {renderElement(row.elements.right)}
              </div>
            </div>
          </div>;
        })}
      </div>
      <Statistics></Statistics>
    </div>
  );
}

export default Homepage;
